import { ReactNode } from "react";
import { useTranslation } from "react-i18next";

import { Stack, Typography } from "@mui/material";
import { FormikProps } from "formik";

import { FormikTextField } from "../../../../../../formik/FormikTextField";
import { FormikYesNoAutocomplete } from "../../../../../../formik/FormikYesNoAutocomplete";
import { FieldWithInfo } from "../../../personal-data/components/field-with-info/FieldWithInfo";
import { DonationsFormValues, DonationsMaxLength } from "../../DonationsView.types";
import { DonationQuestionConfig } from "../../DonationsView.utils";

const TAB = "clients.client.debtSettlement.assetInventory.donationsTab";

interface Props {
  formik: FormikProps<DonationsFormValues>;
  config: DonationQuestionConfig;
  infoContent?: ReactNode;
}

export function DonationQuestion({ formik, config, infoContent }: Props) {
  const { t } = useTranslation();
  const { key, field, detailsField } = config;
  const label = t(`${TAB}.${key}.question`);
  const detailsId = `donations-${detailsField}`;
  const detailsQuestionId = `${detailsId}-question`;

  const question = (
    <FormikYesNoAutocomplete
      id={`donations-${field}`}
      formik={formik}
      path={`answers.${field}`}
      label={label}
      disableClearable
    />
  );

  return (
    <Stack gap={2}>
      {infoContent ? (
        <FieldWithInfo fieldLabel={label} infoContent={infoContent}>
          {question}
        </FieldWithInfo>
      ) : (
        question
      )}
      {formik.values.answers[field] === true && (
        <FormikTextField
          id={detailsId}
          formik={formik}
          path={`answers.${detailsField}`}
          labelNode={
            <Typography id={detailsQuestionId} variant="body2" sx={{ mb: 2 }}>
              {t(`${TAB}.${key}.details`)}
            </Typography>
          }
          label={t(`${TAB}.detailsLabel`)}
          multiline
          minRows={3}
          slotProps={{
            input: {
              inputProps: {
                maxLength: DonationsMaxLength.details,
                "aria-labelledby": `${detailsQuestionId} ${detailsId}-label`,
              },
            },
          }}
        />
      )}
    </Stack>
  );
}
